import { Flex, Typography } from 'antd';
import { ReactNode } from 'react';

const { Text, Title } = Typography;

interface PageTitleProps {
  smallMargin?: boolean;
  title: ReactNode;
  subTitle?: ReactNode;
  rightContent?: ReactNode;
}

export function PageTitle({
  title,
  rightContent,
  subTitle,
  smallMargin,
}: Readonly<PageTitleProps>) {
  const marginClass = smallMargin ? 'mb-16' : 'mb-32';

  function renderSubTitle() {
    if (!subTitle) return;

    return (
      <div className="mt-8">
        {typeof subTitle === 'string' ? (
          <Text type="secondary" className="text-md white-space-pre-wrap">
            {subTitle}
          </Text>
        ) : (
          subTitle
        )}
      </div>
    );
  }

  return (
    <Flex vertical className={marginClass}>
      <Flex justify="space-between" align="center">
        <Title level={1} className="white-space-pre-wrap mr-16">
          {title}
        </Title>
        {rightContent}
      </Flex>
      {renderSubTitle()}
    </Flex>
  );
}
